// extracted by mini-css-extract-plugin
module.exports = {"confidenceAppend":"confidenceAppend__I5Srf","confidence":"confidence__kkcA0","showIcon":"showIcon__lr-tb","badge":"badge__uShEy"};